import React, { useState } from 'react';
import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
} from '@material-ui/core/styles';
import { BrowserRouter as Router } from 'react-router-dom';
import ReactGA from 'react-ga4';
import {
  isChrome,
  isChromium,
  isEdge,
  isFirefox,
  isSafari,
  isMobileSafari,
  isMobile,
} from 'react-device-detect';
import ErrorHandler from '../lib/errorHandler';

import AppRoutes from './app.route';
import BrowserSupportComponent from '../components/browser-support/browser-support.component';
import SafariSupportComponent from '../components/browser-support/safari-support.component';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2C6F78',
    },
  },
  typography: {
    fontFamily: ['lato', 'sans-serif'].join(','),
  },
});

const App = () => {
  // ErrorHandler.init();
  ReactGA.initialize(process.env.REACT_APP_PUBLIC_GOOGLE_ANALYTICS as any);
  ReactGA.send('pageview');
  const [continueOnSafari, setContinueOnSafari] = useState<boolean>(false);
  if (!isSafari && !isChrome && !isFirefox && !isChromium && !isEdge) {
    ErrorHandler.captureError('Unsupported browser');
    return <BrowserSupportComponent />;
  }
  if ((isSafari || isMobileSafari) && isMobile && !continueOnSafari) {
    return (
      <SafariSupportComponent continueClick={() => setContinueOnSafari(true)} />
    );
  }
  return (
    <MuiThemeProvider theme={theme}>
      <Router basename="/">
        <AppRoutes />
      </Router>
    </MuiThemeProvider>
  );
};

export default App;
